module.exports = __webpack_public_path__ + "static/media/FolderListCreate.87618e02.png";